<section #menu id="menu-container" [class.hidden-menu]="!display()">
  <section id="vertical-line-blue"></section>
  <section class="container-items">
    <app-menu-tree [items]="items"></app-menu-tree>
  </section>

  <div class="logos-container">
    <img id="logo-dinamica" [src]="logoPath" alt="PRODUTO EGTEC" />
    <div class="logo-egtec-container">
      <span>Desenvolvido por</span>
      <img src="/assets/img/logos/logo-egtec.png" alt="certificado digital" />
    </div>
  </div>
</section>
